export const LOCAL_STORAGE_KEYS = {
  playKitSeen: 'playKitSeen',
  hasUserLeft: 'hasUserLeft',
  isBannerOpen: 'isBannerOpen',
  editShippingAddressRedirectUrl: 'editShippingAddressRedirectUrl',
};
